import React, { useEffect, useRef } from "react";
import $ from "jquery";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel";
import marqeeimg01 from '../../images/img/owl-img-01.png'
import marqeeimg02 from '../../images/img/owl-img-02.png'
import marqeeimg03 from '../../images/img/owl-img-03.png'
import marqeeimg04 from '../../images/img/owl-img-04.png'
import marqeeimg05 from '../../images/img/owl-img-05.png'
import marqeeimg06 from '../../images/img/owl-img-06.png'
import marqeeimg07 from '../../images/img/owl-img-07.png'
import marqeeimg08 from '../../images/img/owl-img-08.png'
import marqeeimg09 from '../../images/img/owl-img-09.png'
import marqeeimg10 from '../../images/img/owl-img-10.png'
import marqeeimg11 from '../../images/img/owl-img-11.png'
import marqeeimg12 from '../../images/img/owl-img-12.png'
import marqeeimg13 from '../../images/img/owl-img-13.png'
import marqeeimg14 from '../../images/img/owl-img-14.png'
import marqeeimg15 from '../../images/img/owl-img-15.png'
import marqeeimg16 from '../../images/img/owl-img-16.png'
import marqeeimg17 from '../../images/img/owl-img-17.png'
import marqeeimg18 from '../../images/img/owl-img-18.png'
import marqeeimg19 from '../../images/img/owl-img-19.png'
import marqeeimg20 from '../../images/img/owl-img-20.png'
import marqeeimg21 from '../../images/img/owl-img-21.png'
const MarqueeSlider = () => {
    const sliderRef = useRef(null);

    useEffect(() => {
        const $slider = $(sliderRef.current);

        // slick initialize karo
        $slider.slick({
            speed: 5000,
            autoplay: true,
            autoplaySpeed: 0,
            centerMode: true,
            cssEase: "linear",
            slidesToShow: 3,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            initialSlide: 1,
            arrows: false,
            buttons: false,
        });

        // Smooth scroll
        document.querySelectorAll("a.smooth-scroll").forEach((anchor) => {
            anchor.addEventListener("click", function (e) {
                e.preventDefault();
                document
                    .querySelector(this.getAttribute("href"))
                    .scrollIntoView({ behavior: "smooth" });
            });
        });

        // Cleanup jab component unmount ho
        return () => {
            if ($slider.hasClass("slick-initialized")) {
                $slider.slick("unslick");
            }
        };
    }, []);

    return (
        <section className="slice slice-marquee">
            <div className="">
                <div className="slick marquee" ref={sliderRef}>
                    <div className="slick-slide">
                        <div className="inner">
                            <img src={marqeeimg01} className="img-fluid" alt="" />
                        </div>
                    </div>
                    <div className="slick-slide">
                        <div className="inner">
                            <img src={marqeeimg02} className="img-fluid d-block mb-3" alt="" />
                            <img src={marqeeimg03} className="img-fluid" alt="" />
                        </div>
                    </div>
                    <div className="slick-slide">
                        <div className="inner">
                            <img src={marqeeimg04} className="img-fluid" alt="" />
                        </div>
                    </div>
                    <div className="slick-slide">
                        <div className="inner">
                            <img src={marqeeimg05} className="img-fluid" alt="" />
                        </div>
                    </div>
                    <div className="slick-slide">
                        <div className="inner">
                            <img src={marqeeimg06} className="img-fluid" alt="" />
                        </div>
                    </div>
                    <div className="slick-slide">
                        <div className="inner">
                            <img src={marqeeimg07} className="img-fluid d-block mb-3" alt="" />
                            <img src={marqeeimg08} className="img-fluid" alt="" />
                        </div>
                    </div>
                    <div className="slick-slide">
                        <div className="inner">
                            <img src={marqeeimg09} className="img-fluid" alt="" />
                        </div>
                    </div>
                    <div className="slick-slide">
                        <div className="inner">
                            <img src={marqeeimg10} className="img-fluid" alt="" />
                        </div>
                    </div>
                    <div className="slick-slide">
                        <div className="inner">
                            <img src={marqeeimg11} className="img-fluid d-block mb-3" alt="" />
                            <img src={marqeeimg12} className="img-fluid" alt="" />
                        </div>
                    </div>
                    <div className="slick-slide">
                        <div className="inner">
                            <img src={marqeeimg13} className="img-fluid" alt="" />
                        </div>
                    </div>
                    <div className="slick-slide">
                        <div className="inner">
                            <img src={marqeeimg14} className="img-fluid" alt="" />
                        </div>
                    </div>
                    <div className="slick-slide">
                        <div className="inner">
                            <img src={marqeeimg15} className="img-fluid d-block mb-3" alt="" />
                            <img src={marqeeimg16} className="img-fluid" alt="" />
                        </div>
                    </div>
                    <div className="slick-slide">
                        <div className="inner">
                            <img src={marqeeimg17} className="img-fluid" alt="" />
                        </div>
                    </div>
                    <div className="slick-slide">
                        <div className="inner">
                            <img src={marqeeimg18} className="img-fluid" alt="" />
                        </div>
                    </div>
                    <div className="slick-slide">
                        <div className="inner">
                            <img src={marqeeimg19} className="img-fluid d-block mb-3" alt="" />
                            <img src={marqeeimg20} className="img-fluid" alt="" />
                        </div>
                    </div>
                    <div className="slick-slide">
                        <div className="inner">
                            <img src={marqeeimg21} className="img-fluid" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

                    export default MarqueeSlider;
